/**
* 新品 模块 组建
*/
<template>
    <div class="h-news">
      <img src="@/assets/img/new.jpg" class="h-banner" />
      <!-- 产品 图 -->
      <product-serie W v-for="item in newData" :productData="item" :key="item.id"></product-serie>
    </div>
</template>
<script>
//import { newList } from '@/mock' // 新品数据
import { newsData } from '@/api'
import ProductSerie from '@/components/ProductSerie'

export default {
  name: 'News',
  components: { ProductSerie },
  props: {},
  data () {
    return {
      newData: []
    }
  },
  created () {
     this.getNewsData() // 新品数据加载
      
  },
  mounted () {
    //this.newData = newList.result // 使用接口时 此处删除
   // this.getNewsData() // 新品数据加载
  },
  methods: {
    getNewsData () {
      const params = { // 请求参数 --- 根据情况 是否需要
       type:'xp', id: ''
      }
      newsData(params).then(res => {
        this.newData = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .h-news {
    margin-bottom: 20px;
    .h-banner{
      width: 100%;
      margin-bottom: 20px;
    }
  }
</style>
